const orderRouter = {
  path: '/intermodality',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'order',
      name: 'orderList',
      component: () => import('@/pages/intermodality/order/index.vue'),
      meta: {
        keepAlive: true,
        title: '订单列表',
      },
    },
    {
      path: 'orderPage',
      name: 'orderPage',
      component: () => import('@/pages/intermodality/order/orderPage.vue'),
      meta: {
        keepAlive: true,
        title: '订单页面',
      },
    },
  ],
};

export default orderRouter;
